import { CustomizationInfoItem } from "@/dto/order/AliOrderExtraInfoDTO";
import { getAliFreeEntryServiceInfoContentText } from "@/utils/OrderUtils";
import React from "react";

interface AliCustomizationInfoItemProps {
    customizationInfoItem: CustomizationInfoItem;
}

const AliCustomizationInfoItem: React.FC<AliCustomizationInfoItemProps> = function (props) {
    const { customizationInfoItem } = props;

    return (
        <div>
            <p className="fb" style={{ fontSize: "14px" }}>
                定制服务:
            </p>
            {customizationInfoItem.freeEntryServiceInfos?.map((freeEntryServiceInfo, index) => {
                const contentText = getAliFreeEntryServiceInfoContentText(freeEntryServiceInfo.content);

                return (
                    <p key={index} className="mb5 flex">
                        <span className="mr20 fb inline-block w100" style={{ color: "rgb(158,158,158)" }}>
                            {freeEntryServiceInfo.name}
                        </span>
                        <span className="mr20 inline-block w100">{contentText}</span>
                    </p>
                );
            })}
            {customizationInfoItem.payEntryServiceInfos?.map((payEntryServiceInfo, index) => {
                return (
                    <p key={index} className="mb5 flex">
                        <span className="mr20 fb inline-block w100" style={{ color: "rgb(158,158,158)" }}>
                            {payEntryServiceInfo.serviceAttriribute}
                        </span>
                        <span className="mr20 inline-block w100">{payEntryServiceInfo.serviceName}</span>
                        <span className="mr20 inline-block w100">{payEntryServiceInfo.servicePrice}元</span>
                    </p>
                );
            })}
        </div>
    );
};

export default React.memo(AliCustomizationInfoItem);
